import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { DEVICE_TYPE } from "../../constants";

export default function Linkedin() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isLoggedIn } = useSelector(state => state.auth);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (location.search) {
      const code = queryParams.get("code") || null;
      const state = queryParams.get("state") || null;
      if ((code && state)) {
        var splitState = state.split("-");
        const identify = splitState[splitState.length - 1]
        switch (parseInt(identify)) {
          case DEVICE_TYPE.IOS:
            window.location = 'kimbocorp://' + location.search
            break;
          case DEVICE_TYPE.ANDRIOD:
            window.location = `kimbocorp://kimbocorp.io/` + location.search
            break;
          default:
            console.log("isLoggedIn", isLoggedIn)
            break;
        }
      }
    } else {
      console.log("Dashboard")
    }
  }, [dispatch, location]);

  return (
    <></>
  );
}
